import { Component } from "@angular/core";

@Component({
  selector: "app-icon-envelope",
  standalone: true,
  imports: [],
  templateUrl: "./envelope.component.html",
})
export class EnvelopeIconComponent {}
